import { createReducer } from '@reduxjs/toolkit'

import { adGroupsTableColumnsConfig } from 'configuration/tables/adGroupTable'
import { DATES, AD_GROUPS, AD_GROUP_STATES } from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'
import { ENABLED, STATE_FIELD_OPTIONS } from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [AD_GROUPS]: [],
        [AD_GROUP_STATES]: [
            {
                value: ENABLED,
                label: STATE_FIELD_OPTIONS[ENABLED],
            },
        ],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [AD_GROUPS, AD_GROUP_STATES],
        displayState: { [AD_GROUPS]: true, [AD_GROUP_STATES]: true },
        userAdded: [AD_GROUP_STATES],
    },
    table: getDefaultTable(serializeColumns(adGroupsTableColumnsConfig)),
}

export default createReducer(initialState, () => {})
